import { AlertData } from './slice';
import { RootState } from '../../../app/reducer';

export const selectAlertData = ({ modalReducer }: RootState): AlertData | null =>
  modalReducer.alert;
